"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var safeInstanceOf_1 = require("./safeInstanceOf");
/**
 * Check if the given object is HTMLTableCellElement
 * @param obj The object to check
 */
function isHTMLTableCellElement(obj) {
    return safeInstanceOf_1.default(obj, 'HTMLTableCellElement');
}
exports.default = isHTMLTableCellElement;
//# sourceMappingURL=isHTMLTableCellElement.js.map